import React, { Suspense, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import RouteFallback from "../components/shared/RouteFallback";
// import { useSelector } from "react-redux";

function OpenRoot() {
  // const role = useSelector((state) => state?.reducer?.userLoggedIn?.role);
  const location = useLocation();
  const [showHeaderFooter, setShowHeaderFooter] = useState(true);

  useEffect(() => {
    setShowHeaderFooter(location.pathname.split("/").length <= 2);
  }, [location.pathname]);

  if (showHeaderFooter) {
    const isLanding = location.pathname === "/";
    const isAuthPage = location.pathname === "/loginPage" || location.pathname === "/register";
    return (
      <>
        {/* <LoadingBarProgress /> */}
        <div className="flex overflow-x-hidden bg-white dark:bg-gray-900">
          <div className="w-full" style={!isLanding && !isAuthPage ? { paddingTop: "var(--fk-header-h)" } : undefined}>
            <Header />
            <Suspense fallback={<RouteFallback />}>
              <Outlet />
            </Suspense>
            {!isLanding ? <Footer /> : null}
          </div>
        </div>
      </>
    );
  } else {
    return (
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
    );
  }
}

export default OpenRoot;
